import React from 'react';
import { ApolloProvider } from 'react-apollo';
import QueryClientContext from 'contexts/queryClientContext';

export default ({ children }) => (
  <QueryClientContext.Consumer>
    {client => <ApolloProvider client={client}>{children}</ApolloProvider>}
  </QueryClientContext.Consumer>
);
